<template>
  <div class="explore-header">
    <div class="explore-header__title">
      <div>
        <h1 class="explore-header__page-title">{{ $t('menu.explore') }}</h1>
      </div>
      <div class="explore-header__subtitle">
        <p class="explore-header__subtitle-count">
          {{ this.totalCount.toLocaleString('en-US') + ' ' + $t('title.tenders') }}
        </p>
      </div>
    </div>
    <!-- Phones: the search goes under the header, beside the filters (PhoneFilterBar). -->
    <div v-if="!isPhone" class="explore-header__search-bar">
      <ExploreBar />
    </div>
  </div>
</template>

<script>
import ExploreBar from '@/components/page-explore/ExploreBar';
import { viewport } from '@/util/viewport';

export default {
  name: 'TendersHeader',
  components: { ExploreBar },
  props: ['totalCount'],
  computed: {
    isPhone() {
      return viewport.size === 'phone';
    },
  },
};
</script>

<style lang="scss">
.explore-header {
  background: $color-white;
  box-shadow: $shadow-dropdown;
  display: flex;
  flex-direction: row;
  height: $header-height;
  position: sticky;
  top: $menu-top-bar-height;
  z-index: $header-index;
  padding: 16px 32px;
  gap: 16px;

  &__title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 1 auto;
  }

  &__page-title {
    color: $color-normal;
    display: flex;
    font-family: $font-family-raleway;
    font-size: $font-size-page-title;
    font-weight: normal;
    padding-right: 60px;
    margin: 0 8px 0 0;
    position: relative;
    text-transform: uppercase;

    &::after {
      background: $color-border;
      content: '';
      display: block;
      height: 50px;
      position: absolute;
      right: 0;
      top: calc(50% - 16px);
      width: 1px;
    }
  }

  &__subtitle {
    align-items: center;
    display: flex;
    flex-wrap: wrap;

    &-count {
      color: $color-neutral;
      font-size: $font-size-small;
      font-weight: bold;
      margin: 0;
      margin-right: 16px;
      text-transform: uppercase;
    }
  }

  &__search-bar {
    align-items: center;
    display: flex;
    position: relative;
    justify-content: flex-start;
    flex: 1;
    max-width: 700px;
  }

  @media screen and (max-width: 1080px) {
    gap: 0px;

    &__page-title {
      &::after {
        display: none;
      }
    }
  }

  // Phones: the title and count on one line, the search under them across the screen.
  @include phone-page-header {
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px $phone-page-gutter;
  }

  &__page-title {
    @include phone-page-title;
  }

  @include screen-below('tablet') {
    &__title {
      flex-direction: row;
      align-items: baseline;
      gap: 8px;
      min-width: 0;
    }

    &__subtitle-count {
      margin-right: 0;
      font-size: 12px;
      white-space: nowrap;
    }

    &__search-bar {
      flex-basis: 100%;
      max-width: none;
    }
  }
}
</style>
